import { Link } from 'react-router-dom';
import { categories, tvShows } from '@/mocks/tv-shows';

export default function ExploreSection() {
  const tagGroups = [
    { name: '古装仙侠', shows: tvShows.filter(s => s.tags.includes('古装') || s.tags.includes('仙侠')).slice(0, 4) },
    { name: '悬疑刑侦', shows: tvShows.filter(s => s.tags.includes('悬疑') || s.tags.includes('刑侦')).slice(0, 4) },
    { name: '都市爱情', shows: tvShows.filter(s => s.tags.includes('爱情') || s.tags.includes('都市')).slice(0, 4) },
  ];

  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14">
      <div className="text-center mb-10">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
          探索更多精彩
        </h2>
        <p className="text-sm text-foreground-500 mt-2">按类型、地区、年代快速找到你想看的电视剧</p>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4 mb-10">
        {categories.filter(c => c.slug !== 'all').map((cat) => (
          <Link
            key={cat.slug}
            to={`/category/${cat.slug}`}
            className="flex items-center gap-3 p-4 rounded-xl bg-background-100 hover:bg-primary-50 border border-background-200/70 hover:border-primary-200 transition-all duration-200 group cursor-pointer"
          >
            <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-600 group-hover:bg-primary-500 group-hover:text-white transition-all duration-200">
              <i className={`${cat.icon} text-lg`}></i>
            </div>
            <div>
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-700 transition-colors">
                {cat.name}
              </span>
              <p className="text-xs text-foreground-500 mt-0.5">
                {tvShows.filter(s => s.categorySlug === cat.slug).length} 部
              </p>
            </div>
          </Link>
        ))}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {tagGroups.map((group) => (
          <div key={group.name} className="bg-background-100 rounded-xl p-5 border border-background-200/70">
            <h3 className="font-heading text-base font-bold text-foreground-900 mb-4 flex items-center gap-2">
              <i className="ri-hashtag text-primary-500"></i>
              {group.name}
            </h3>
            <div className="space-y-3">
              {group.shows.map((show) => (
                <Link
                  key={show.id}
                  to={`/article/${show.id}`}
                  className="flex items-center gap-3 group cursor-pointer"
                >
                  <div className="w-10 h-14 rounded-md overflow-hidden flex-shrink-0">
                    <img
                      src={show.imageUrl}
                      alt={show.title}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-medium text-foreground-800 truncate group-hover:text-primary-600 transition-colors">
                      {show.title}
                    </p>
                    <div className="flex items-center gap-2 mt-1">
                      <span className="text-xs text-accent-500">
                        <i className="ri-star-fill text-[10px] mr-0.5"></i>{show.rating}
                      </span>
                      <span className="text-xs text-foreground-500">{show.year}</span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}